const ButterflyKisses = [
	'[Verses]',
	"There's two things I know for sure",
	'She was sent here from heaven',
	"And she's daddy's little girl",
	'As I drop to my knees by her bed at night',
	'She talks to Jesus',
	'and I close my eyes',
	'And I thank God for all the joy in my life',
	'Oh, but most of all',
	'',
	'For butterfly kisses after bedtime prayer',
	"Stickin' little white flowers all up in her hair",
	"Walk beside the pony, Daddy it's my first ride",
	'I know the cake looks funny, Daddy but I sure tried',
	"With all that I've done wrong I must 'ave done somethin' right",
	"To deserve a hug ev'ry mornin' and butterfly kisses at night",
	'',
	'Sweet sixteen today',
	"She's looking like her mamma a little more ev'ry day",
	'One part woman the other part girl',
	'To perfume and makeup from ribbons and curls',
	'Trying her wings out in a great big world',
	'But I remember...',
	'',
	'Butterfly kisses after bedtime prayer',
	"Stickin' little white flowers all up in her hair",
	"You know how much I love you daddy but if you don't mind",
	"I'm only gonna kiss you on the cheek this time",
	"With all that I've done wrong I must 'ave done somethin' right",
	"To deserve her love ev'ry mornin' and butterfly kisses at night",
	'',
	'Oh precious time',
	'like the wind, the years go by',
	'Precious butterfly',
	'spread your wings and fly',
	'',
	"She'll change her name today",
	"She'll make a promise",
	"and I'll give her away",
	'Standing in the bride room',
	'just staring at her',
	"She asked me what I'm thinking",
	'and I said, "I\'m not sure"',
	'"I just feel like I\'m loosing my baby girl"',
	'She leaned over...and gave me',
	'',
	'Butterfly kisses with her mamma there',
	"Stickin' little white flowers all up in her hair",
	'"Walk me down the isle, Daddy, it\'s just about time"',
	'"Does my wedding gown look pretty, Daddy?"',
	'"Daddy, don\'t cry"',
	"With all that I've done wrong",
	"I must 'ave done somethin' right",
	'',
	"To deserve her love ev'ry mornin'",
	'and butterfly kisses',
	"Couldn't ask God for more",
	'then this is what love is',
	'I know I gotta let her go',
	"but I'll always remember",
	"Ev'ry hug in the mornin'",
	'and butterfly kisses',
];

export default ButterflyKisses;
